import { makeStyle } from '../../../../../utils';
import { columnCenter, subTitle1, black, bold, caption, secondary, h6, rowCenter, subTitle2, overline, button, h5 } from '../../../../../resources/styles';
import view from '../../../../../Enums';

const styles = {};

styles['header'] = makeStyle( {
    justifyContent: 'space-between', padding: '20px 20px 20px 32px',display:'flex'
},null,null,{padding:'12px 12px 12px 20px'});

styles['title'] = makeStyle([h6, black, { letterSpacing: '-0.35px', marginRight: 32 }],null,null,{fontSize:'16px'});

styles['highlight'] = makeStyle({ fontSize: 24, color: 'var(--theme-color)' },null,null,{fontSize:'18px'});

styles['content'] = makeStyle({ margin: '0 32px 32px' },null,null,{margin:'0 20px 20px'});

styles['content_title'] = makeStyle(subTitle1);

styles['ota_container'] = makeStyle([columnCenter, { alignItems: 'stretch', marginTop: 24 }]);

styles['field'] = makeStyle({ alignSelf: 'stretch' });

styles['adornment'] = makeStyle([caption, secondary, { letterSpacing: '0.2px', cursor: 'pointer', whiteSpace: 'nowrap', marginLeft: 12 }]);
styles['adornment_icon'] = makeStyle([secondary, { cursor: 'pointer' }]);

styles['actions_container'] = makeStyle([rowCenter, { marginTop: 12, justifyContent: 'center', flexWrap: 'wrap' }], null, null, columnCenter);

styles['action_btn_container'] = makeStyle({flex: 1, margin: '12px 12px 0',},{maxWidth: 230},view.DESKTOP,{margin: '12px 0 0', alignSelf: 'stretch'})

styles['action'] = makeStyle({
    width:'100%',
    borderRadius: 6,
    backgroundColor: 'var(--theme-color)',
    textAlign: 'center',
    color: 'white',
    padding: '8px 16px',
    display: 'flex',
    alignItems: 'center',
    ...button,
}, { maxWidth: 230 }, view.DESKTOP, {});

styles['earning'] = makeStyle([h6, { textAlign: 'center', backgroundColor: '#eee', padding: '16px 32px' }],null,null,{fontSize:'16px'});

styles['earning_highlight'] = makeStyle({ ...h5, color: 'var(--theme-color)' },null,null,{fontSize:'18px'});

export default styles;